<template lang="pug">
  multiselect(
    :value="value"
    :options="classificationList"
    placeholder="Type to search"
    label="Desc_en"
    track-by="Desc_en"
    name="code"
    @input="onInput"
    :disabled="disabled"
    :loading="classification_loading"
    :internalSearch="true"
    @search-change="loadClassification"
  )
    template(slot="option" slot-scope="props")
      span.block {{ props.option.Desc_en }}
</template>

<script>
import jsonData from './e-invoice/ClassificationCodes.json';
import _ from 'lodash';

export default {
    props: {
        value: {
            type: null,
            default: () => null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            classificationList: [],
            classification_loading: false,
        };
    },
    mounted() {
        this.loadClassification();
    },
    methods: {
        onInput(value) {
            this.$emit('input', value);
        },
        loadClassification: _.debounce(function(query) {
            this.classification_loading = true;

            if (query) {
                this.classificationList = jsonData.filter(item =>
                    item.Desc_en.toLowerCase().includes(query.toLowerCase()),
                );
            } else {
                this.classificationList = jsonData;
            }

            this.classification_loading = false;
        }, 500),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/eClassificationSelector.vue